//REGISTER
export const PATNERS = "/patners"
export const BRANCH = "/masters/branch"
export const EMPLOYEE = "/masters/employees"
export const ROLE = "/masters/roles"
export const COURIER = "/masters/couriers"
export const COURIERRATE = "/masters/courier_rates"
export const SHIPMENT = "/shipments"
export const REPORTS = "/reports"
export const WP_URL = "/masters/settings/wp"
export const USER = "/users/password-update"
export const ZONE = "/masters/zone"
export const PINCODES = "/pincodes"
